module.exports = __webpack_public_path__ + "static/img/point-active.7073e379.png";